<template>
    <div>
        <base-input label="Device Destinations">
            <div class="form-row">
                <div class="col-12 mt-2" style="margin-left:-10px;">
                    <s-i-p-device-selector v-bind:initial-selected-devices="devices"
                                           v-on:add="$emit('device-add', $event)"
                                           v-on:remove="$emit('device-remove', $event)"></s-i-p-device-selector>
                </div>
            </div>
        </base-input>

        <base-input label="Number Destinations">
            <div class="form-row">
                <phone-number-selector v-bind:initial-phone-numbers="numbers"
                                       v-on:update="$emit('number-update', $event)"
                                       v-on:remove="$emit('number-remove', $event)"
                                       v-on:add="$emit('number-add', $event)"></phone-number-selector>
            </div>
        </base-input>
    </div>
</template>
<script>
    import PhoneNumberSelector from "../PhoneNumbers/PhoneNumberSelector"
    import SIPDeviceSelector from "../SIPDevices/SIPDeviceSelector"

    export default {
        name: 'device-number-selector',
        components: {PhoneNumberSelector, SIPDeviceSelector},
        props: {
            devices: Array,
            numbers: Array,
        }
    }
</script>
